import ParkAndRideFacilityIcon from '@/assets/icons/map-markers/facilities/park-and-ride-facility.svg?react';
import ParkingFacilityIcon from '@/assets/icons/map-markers/facilities/parking-facility.svg?react';
import PickupIcon from '@/assets/icons/map-markers/facilities/pickup-parking-facility.svg?react';
import BusStationIcon from '@/assets/icons/map-markers/stations/bus-station.svg?react';
import TrainStationIcon from '@/assets/icons/map-markers/stations/train-station.svg?react';
import { MapLayer } from '@/types/MapLayer';

const ICONS = {
  [MapLayer.PARKING_FACILITY]: ParkingFacilityIcon,
  [MapLayer.PARK_AND_RIDE_FACILITY]: ParkAndRideFacilityIcon,
  [MapLayer.PICKUP_PARKING_FACILITY]: PickupIcon,
  [MapLayer.TRAIN_STATION]: TrainStationIcon,
  [MapLayer.BUS_STATION]: BusStationIcon,
} as const;

interface MapLayerIconProps {
  mapLayer: keyof typeof MapLayer;
  size?: number;
}

export function MapLayerIcon({ mapLayer, size = 24 }: MapLayerIconProps) {
  const Icon = ICONS[mapLayer];

  return <Icon height={size} width={size} />;
}
